import React, { useState } from 'react';
import { Separator } from "@/components/ui/separator";
import { AppErrorBoundary } from "@/components/error-handling/AppErrorBoundary";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { JobSearchResults } from '@/components/job-search/JobSearchResults';
import { LeadCreationDialog } from '@/components/job-search/LeadCreationDialog';

interface JobSearchResult {
  id: string;
  job_title?: string;
  company_name?: string;
  location?: string;
  description?: string;
  job_url?: string;
}

const ClientBizDevPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("job-search");
  const [isLeadCreationOpen, setIsLeadCreationOpen] = useState(false);
  const [selectedJobForLead, setSelectedJobForLead] = useState<JobSearchResult | null>(null);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Business Development</h1>
          <p className="text-muted-foreground mt-1">
            Find leads, track opportunities, and manage business development activities.
          </p>
        </div>
        <Button onClick={() => navigate('/leads/new')}>
          <Plus className="mr-2 h-4 w-4" /> Add Lead
        </Button>
      </div>
      
      <Separator />
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList>
          <TabsTrigger value="job-search">Job Search</TabsTrigger>
          {/* Add other tabs here if needed */}
        </TabsList>
        
        <TabsContent value="job-search" className="mt-6">
          <Card>
            <CardHeader className="pb-3">
              <CardTitle>Job Search & Lead Generation</CardTitle>
            </CardHeader>
            <CardContent>
              <AppErrorBoundary componentName="JobSearchResults">
                <JobSearchResults 
                  onCreateLead={(job) => {
                    setSelectedJobForLead(job);
                    setIsLeadCreationOpen(true);
                  }}
                />
              </AppErrorBoundary>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Updated LeadCreationDialog props */}
      {selectedJobForLead && (
        <LeadCreationDialog
          isOpen={isLeadCreationOpen}
          onOpenChange={setIsLeadCreationOpen}
          selectedJob={selectedJobForLead}
        />
      )}
    </div>
  );
};

export default ClientBizDevPage;
